(function () {
  'use strict';

  var CSS = [
    '.rm-target { position: relative; }',
    '.rm-target.rm-collapsed { max-height: 150px; overflow: hidden; }',
    '.rm-target.rm-expanded { max-height: none; overflow: visible; }',
    '.rm-fade { position: absolute; bottom: 0; left: 0; right: 0; height: 80px; pointer-events: none; transition: opacity 0.3s ease; z-index: 1; }',
    '.rm-target.rm-expanded .rm-fade { opacity: 0; }',
    '.rm-toggle-btn { display: inline-flex; align-items: center; gap: 5px; margin-top: 10px; padding: 0; background: none; border: none; cursor: pointer; font-size: 0.875rem; font-family: inherit; font-weight: 500; color: currentColor; text-decoration: underline; text-underline-offset: 3px; letter-spacing: 0.02em; transition: opacity 0.2s ease; }',
    '.rm-toggle-btn:hover { opacity: 0.7; }',
    '.rm-toggle-btn:focus-visible { outline: 2px solid currentColor; outline-offset: 3px; border-radius: 2px; }',
    '.rm-chevron { display: inline-block; width: 0.75em; height: 0.75em; border-right: 1.5px solid currentColor; border-bottom: 1.5px solid currentColor; transform: rotate(45deg); transition: transform 0.3s ease; flex-shrink: 0; position: relative; top: -1px; }',
    '.rm-target.rm-expanded + .rm-toggle-btn .rm-chevron { transform: rotate(225deg); top: 2px; }',
    '.rm-target.rm-transitioning { transition: max-height 0.4s ease; overflow: hidden; }'
  ].join('\n');

  function injectStyles() {
    if (document.getElementById('rm-styles')) return;
    var style = document.createElement('style');
    style.id = 'rm-styles';
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  function getBgColor(el) {
    var node = el;
    while (node && node !== document.documentElement) {
      var bg = window.getComputedStyle(node).backgroundColor;
      if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') return bg;
      node = node.parentElement;
    }
    return 'rgb(255, 255, 255)';
  }

  function buildGradient(bgColor) {
    var rgbaTransparent = bgColor.replace(/^rgb\(/, 'rgba(').replace(/\)$/, ', 0)');
    return 'linear-gradient(to bottom, ' + rgbaTransparent + ' 0%, ' + bgColor + ' 100%)';
  }

  function needsToggle(el) {
    var pCount = el.querySelectorAll('p, li, h1, h2, h3, h4, h5, h6').length;
    if (pCount > 3) return true;
    var prev = el.style.maxHeight;
    var prevOverflow = el.style.overflow;
    el.style.maxHeight = 'none';
    el.style.overflow = 'visible';
    var h = el.scrollHeight;
    el.style.maxHeight = prev;
    el.style.overflow = prevOverflow;
    return h > 200;
  }

  function initReadMore(el) {
    if (el.dataset.rmInit) return;
    el.dataset.rmInit = 'true';
    if (!needsToggle(el)) return;

    el.classList.add('rm-target', 'rm-collapsed');
    el.style.position = 'relative';

    var fade = document.createElement('div');
    fade.className = 'rm-fade';
    fade.style.background = buildGradient(getBgColor(el));
    el.appendChild(fade);

    var btn = document.createElement('button');
    btn.className = 'rm-toggle-btn';
    btn.setAttribute('aria-expanded', 'false');
    btn.type = 'button';

    var label = document.createElement('span');
    label.className = 'rm-label';
    label.textContent = 'Read more';
    var chevron = document.createElement('span');
    chevron.className = 'rm-chevron';
    chevron.setAttribute('aria-hidden', 'true');
    btn.appendChild(label);
    btn.appendChild(chevron);

    el.parentNode.insertBefore(btn, el.nextSibling);

    btn.addEventListener('click', function () {
      var isCollapsed = el.classList.contains('rm-collapsed');
      if (isCollapsed) {
        var fullH = el.scrollHeight + 'px';
        el.classList.add('rm-transitioning');
        el.style.maxHeight = fullH;
        var onEnd = function () {
          el.removeEventListener('transitionend', onEnd);
          el.classList.remove('rm-collapsed', 'rm-transitioning');
          el.classList.add('rm-expanded');
          el.style.maxHeight = '';
        };
        el.addEventListener('transitionend', onEnd);
        btn.setAttribute('aria-expanded', 'true');
        label.textContent = 'Read less';
      } else {
        el.style.maxHeight = el.scrollHeight + 'px';
        void el.offsetHeight;
        el.classList.add('rm-transitioning');
        el.classList.remove('rm-expanded');
        el.classList.add('rm-collapsed');
        el.style.maxHeight = '150px';
        var onEnd2 = function () {
          el.removeEventListener('transitionend', onEnd2);
          el.classList.remove('rm-transitioning');
          el.style.maxHeight = '';
        };
        el.addEventListener('transitionend', onEnd2);
        btn.setAttribute('aria-expanded', 'false');
        label.textContent = 'Read more';
      }
    });
  }

  function init() {
    injectStyles();
    // Auto-detect: find all rte-formatter.rte and .rte elements with rich content
    var targets = document.querySelectorAll('rte-formatter.rte, .text-block.rte');
    targets.forEach(initReadMore);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
